import { logger } from "common/utilities/logger";

export const copyTextToClipboard = (text: string) => {
  try {
    return navigator.clipboard.writeText(text);
  } catch (error) {
    logger.error("[copyTextToClipboard] Failed to copy text to clipboard", error);
    return undefined;
  }
};
